type Side = 'client' | 'server'

const side = (): Side => (typeof window === 'undefined' ? 'server' : 'client')

export default side
